<template>
  <div  class="forecast">
    <div class="enter">
      <div class="qw-container">
        <h3>{{ c.qw0 }}</h3>
        <div class="input-container">
          <span class="input-label">
            <input class="input-val moneyValInput"
            :max="money.max" :step="money.step" :min="money.min" 
            v-model="moneyValInput" type="text"
            @focus="focusHandler($event, 'moneyVal')"
            @blur="blurHandler($event, 'moneyVal')"
            @change="handleInputChange('moneyVal', 'moneyValInput', money)"
            @input="handleInput($event, 'moneyVal', 'moneyValInput', money)">
            <div class="input-buffer moneyValHide">
              {{ moneyValInput.toLocaleString('ru') }}
            </div>
            <span class="currency moneyValCy">₽</span>
          </span>
          <RangeSlider class="slider" v-model="moneyVal"
            :min="money.min" :max="money.max" :step="money.step"
            @change="onSliderFocus('moneyVal')"/>
          <div class="sub-container">
            <span class="sub-span">{{ formatNumber(money.min.toString()) }} ₽</span>
            <span class="sub-span">{{ formatNumber(money.max.toString()) }} ₽</span>
          </div>
        </div>
      </div>

      <div class="qw-container">
        <h3>{{ c.qw1 }}</h3>
        <div class="grid" :key="moneyVal">
          <div class="category">
            <span>{{ c.cardsCategory[0] }}</span>
            <button class="info"
              @click="openPopup($parent.dimensions[0],'index', $parent.dimensions[0].dataset)">?</button>
          </div>
          <div class="category">
            <span>{{ c.cardsCategory[1] }}</span>
            <button class="info"
              @click="openPopup($parent.dimensions[1],'index', $parent.dimensions[1].dataset)">?</button>
          </div>
          <div class="category">
            <span>{{ c.cardsCategory[2] }}</span>
            <button class="info"
              @click="openPopup($parent.dimensions[2],'index', $parent.dimensions[2].dataset)">?</button>
          </div>

          <div class="card"  v-for="(card, id) in cards" :key="id"
            @click="openPopup($parent.dimensions[id],'unit', cards[id])">
            <img :src="card.icon" alt="">
            <div class="container">
              <p>{{ card.name }}</p>
              <button>
                {{ formatNumber(card.value>=1000000? 
                  ((card.value/1000000).toFixed(4)).toString().slice(0, -3) :
                  card.value.toString()
                , 1) + (card.value>=1000000? ' млн ₽': ' ₽') }} </button>
            </div>
          </div>
        </div>
      </div>

      <div class="qw-container">
        <h3>{{ c.qw2 }}</h3>
        <div class="input-container">

          <span class="input-label">
            <input class="input-val timeValInput"
            :max="time.max" :step="time.step" :min="time.min" 
            v-model="timeValInput" type="text"
            @focus="focusHandler($event, 'timeVal')"
            @blur="blurHandler($event, 'timeVal')"
            @change="handleInputChange('timeVal', 'timeValInput', time)"
            @input="handleInput($event, 'timeVal', 'timeValInput', time)">
            <div class="input-buffer timeValHide">
              {{ timeValInput.toLocaleString('ru') }}
            </div>
            <span class="currency timeValCy">
              {{ yearName(timeValInput) }}
            </span>
          </span>
          <RangeSlider class="slider" v-model="timeVal"
            :min="time.min" :max="time.max" :step="time.step"
            @change="onSliderFocus('timeVal')"/>
          <div class="sub-container">
            <span class="sub-span">{{ time.min + yearName(time.min) }}</span>
            <span class="sub-span">{{ time.max + yearName(time.max) }}</span>
          </div>
        </div>
      </div>
      <a class="btn" href="#output">{{ c.btn }}</a>
    </div>
    <div class="output">
      <header id="output">
        <h2>{{ c.outputHeading }}</h2>
        <p class="sub-heading">{{ c.outputSubHeading }}</p>
      </header>

      <div class="answers">
        <div class="ans-container">
          <h3>{{ c.ans0 }}
            <button class="info-heading"
              @click="openPopup($parent.finTools[0],'finTools')">?</button>
          </h3>
          <div class="grid">
            <div class="category">
              <span>{{ c.cardsCategory[0] }}</span>
              <span class="info" :class="getClass(0, 0)"></span>
            </div>
            <div class="category">
              <span>{{ c.cardsCategory[1] }}</span>
              <span class="info" :class="getClass(0, 1)"></span>
            </div>
            <div class="category">
              <span>{{ c.cardsCategory[2] }}</span>
              <span class="info" :class="getClass(0, 2)"></span>
            </div>
            <div class="card"  v-for="(card, id) in cardsForecastNone" :key="id"
              :class="getClass(0, id)"
              @click="openPopup($parent.dimensions[id],'unit', cardsForecastNone[id])">
              <img :src="card.icon" alt="">
              <div class="container">
                <p>{{ card.name }}</p>
                <button>
                  {{ formatNumber(card.value>=1000000? 
                    ((card.value/1000000).toFixed(4)).toString().slice(0, -3) :
                    card.value.toString()
                  , 1) + (card.value>=1000000? ' млн ₽': ' ₽') }} </button>
              </div>
            </div>
          </div>
        </div>
        <div class="ans-container">
          <h3>{{ c.ans1 }}
            <button class="info-heading"
              @click="openPopup($parent.finTools[1],'finTools')">?</button>
          </h3>
          <div class="result">
            <p class="value">
              {{ formatNumber(this.moneyInBank.toString()) }}
              <span>₽</span>
            </p>
            <p class="value-description">Ставка 
              <span>{{( $parent.finTools[1].coefficient*100*12).toFixed(2) }} %</span>, 
              <span>+
              {{ formatNumber((moneyInBank - moneyVal)>=1000000? 
                    (((moneyInBank - moneyVal)/1000000).toFixed(4)).toString().slice(0, -3) :
                    (moneyInBank - moneyVal).toString()
                  , 1) + ((moneyInBank - moneyVal)>=1000000? ' млн ₽': ' ₽') }}
              </span> за 
              <span>{{timeVal + yearName(timeVal) }}</span>
            </p>
          </div>
          <div class="grid">
            <div class="category">
              <span>{{ c.cardsCategory[0] }}</span>
              <span class="info" :class="getClass(1, 0)"></span>
            </div>
            <div class="category">
              <span>{{ c.cardsCategory[1] }}</span>
              <span class="info" :class="getClass(1, 1)"></span>
            </div>
            <div class="category">
              <span>{{ c.cardsCategory[2] }}</span>
              <span class="info" :class="getClass(1, 2)"></span>
            </div>
            <div class="card"  v-for="(card, id) in cardsForecastBank" :key="id"
              :class="getClass(1, id)"
              @click="openPopup($parent.dimensions[id],'unit', cardsForecastBank[id])">
              <img :src="card.icon" alt="">
              <div class="container">
                <p>{{ card.name }}</p>
                <button>
                  {{ formatNumber(card.value>=1000000? 
                    ((card.value/1000000).toFixed(4)).toString().slice(0, -3) :
                    card.value.toString()
                  , 1) + (card.value>=1000000? ' млн ₽': ' ₽') }} </button>
              </div>
            </div>
          </div>
        </div>
        <div class="ans-container">
          <h3>{{ c.ans2 }}
            <button class="info-heading"
              @click="openPopup($parent.finTools[2],'finTools')">?</button>
          </h3>
          <div class="result">
            <p class="value">
              {{ formatNumber(this.moneyInInvest.toString()) }}
              <span>₽</span>
            </p>
            <p class="value-description">Ставка 
              <span>{{( $parent.finTools[2].coefficient*100*12).toFixed(2) }} %</span>, 
              <span>+
              {{ formatNumber((moneyInInvest - moneyVal)>=1000000? 
                    (((moneyInInvest - moneyVal)/1000000).toFixed(4)).toString().slice(0, -3) :
                    (moneyInInvest - moneyVal).toString()
                  , 1) + ((moneyInInvest - moneyVal)>=1000000? ' млн ₽': ' ₽') }}
              </span> за 
              <span>{{timeVal + yearName(timeVal) }}</span>
            </p>
          </div>
          <div class="grid">
            <div class="category">
              <span>{{ c.cardsCategory[0] }}</span>
              <span class="info" :class="getClass(2, 0)"></span>
            </div>
            <div class="category">
              <span>{{ c.cardsCategory[1] }}</span>
              <span class="info" :class="getClass(2, 1)"></span>
            </div>
            <div class="category">
              <span>{{ c.cardsCategory[2] }}</span>
              <span class="info" :class="getClass(2, 2)"></span>
            </div>
            
            <div class="card" v-for="(card, id) in cardsForecastInvest" :key="id"
              :class="getClass(2, id)"
              @click="openPopup($parent.dimensions[id], 'unit', cardsForecastInvest[id])">
              <img :src="card.icon" alt="">
              <div class="container">
                <p>{{ card.name }}</p>
                <button>
                {{ formatNumber(card.value>=1000000? 
                    ((card.value/1000000).toFixed(4)).toString().slice(0, -3) :
                    card.value.toString()
                  , 1) + (card.value>=1000000? ' млн ₽': ' ₽') }} </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <a href="#top" class="btn">{{ c.btnMore }}</a>
    </div>
    <footer>
      <h4>{{ c.footerText.beforeEmail }}
        <a :href="'mailto:'+c.footerText.email">{{ c.footerText.email }}</a>
      </h4>
      <div class="policy">
        <p v-for="(p, i) in settings.policy" :key="i">
          {{ p }}
        </p>
      </div>
    </footer>
  </div>
</template>


<script>
import RangeSlider from '@/assets/vue-range-slider'
import '@/assets/vue-range-slider.css'

export default {
  components: {
    RangeSlider,
  },
  data(){return {
    c: this.$parent.content[1],
    settings: this.$parent.content[3],

    moneyVal: 15000,
    moneyValInput: 15000,
    money: {
      min: 5000,
      max: 10000000,
      step: 5000,
      minlength: 4,
      maxlength: 8
    },

    timeVal: 3,
    timeValInput: 3,
    time: {
      min: 1,
      max: 25,
      step: 1,
      minlength: 1,
      maxlength: 2
    },

    cards: [],
    cardsForecastNone: [],
    cardsForecastBank: [],
    cardsForecastInvest: [],

    moneyInBank: 15000,
    moneyInInvest: 15000,

    indexes: [],
    indexesFin: [],

    animation: false,
  }}, 
  mounted() {
    this.money = {
      min: +this.settings.forecast.moneyInput.min,
      max: +this.settings.forecast.moneyInput.max,
      step: +this.settings.forecast.moneyInput.step,
      minlength: +this.settings.forecast.moneyInput.min.length,
      maxlength: +this.settings.forecast.moneyInput.max.length
    }
    this.time = {
      min: +this.settings.forecast.timeInput.min,
      max: +this.settings.forecast.timeInput.max,
      step: +this.settings.forecast.timeInput.step,
      minlength: +this.settings.forecast.timeInput.min.length,
      maxlength: +this.settings.forecast.timeInput.max.length
    }    
    this.moneyVal = +this.settings.forecast.moneyInput.start
    this.moneyValInput = this.moneyVal.toLocaleString('ru')
    this.timeVal = +this.settings.forecast.timeInput.start
    this.timeValInput = +this.settings.forecast.timeInput.start

    this.cards = this.getCards()
    this.cardsForecastNone = this.getForecast(0)
    this.cardsForecastBank = this.getForecast(1)
    this.cardsForecastInvest = this.getForecast(2)
    this.getMoneyInBank()
    this.getMoneyInInvest()

    this.resize('moneyVal')
    this.resize('timeVal')

  },
  methods: {
    resize(name) {
      let currency = document.querySelector(`.${name}Cy`)
      let hide = document.querySelector(`.${name}Hide`)
      hide.textContent = this[name+'Input'].toLocaleString('ru') || '0'
      currency.style.transform = `translateX(${+hide.offsetWidth/2 + 10}px)`
      if (name === 'timeVal') currency.style.transform = `translateX(calc( 50% + ${+hide.offsetWidth/2 -10}px))`
    },
    getClass(finTool, i) {
      if (!this.indexesFin[finTool]) return 'none'
      if (this.indexesFin[finTool][i] === this.indexes[i]) return 'none'
      if (this.indexesFin[finTool][i] > this.indexes[i]) return 'up'
      if (this.indexesFin[finTool][i] < this.indexes[i]) return 'down'
    },
    getMoneyInInvest() {
      let money = this.getStockpilingToDate(this.timeVal*12, this.moneyVal, this.$parent.finTools[2])
      this.moneyInInvest = Math.round(money)
    },
    getMoneyInBank() {
      let money = this.getStockpilingToDate(this.timeVal*12, this.moneyVal, this.$parent.finTools[1])
      this.moneyInBank = Math.round(money)
    },
    getPriceToDate(months, dimension){
      let price = dimension.startPrice;
      for(months; months >0; months--){
        price += price * dimension.coefficient;
      }
      return price;
    },
    getStockpilingToDate(months, startMoney, financeTool){
      let stockpiling = startMoney;
      for(months; months >0; months--){
        stockpiling += stockpiling * financeTool.coefficient;
      }
      return stockpiling ;
    },
    getCards() {
      let cards = []
      let indexes = []
      let moneyVal = this.moneyVal || 15000
      let data = this.$parent.dimensions
      data.forEach((item, i) => {
        let startPrice = data[i].startPrice
        let card = null
        item.dataset.forEach((el, id) => {
          let minPrice = startPrice * el.min
          let maxPrice = startPrice * el.max
          if (moneyVal > minPrice) {
            indexes[i]= +id
            card = {
              startPrice: Math.floor(moneyVal<maxPrice? moneyVal: maxPrice),
              coefficient: item.coefficient,
              name: el.name,
              description: el.description,
              min: el.min,
              max: el.max,
              icon: el.icon,
              value: Math.floor(moneyVal<maxPrice? moneyVal: maxPrice),
            }
          }
        })
        cards.push(card)
      });
      this.indexes = [...indexes]
      return cards
    },
    openPopup(content, mode, data) {
      this.$parent.popupContent = content
      this.$parent.popupMode = mode
      if (data && mode === 'index') data = data.find(el => el.unit)
      this.$parent.popupData = data
      this.$parent.popupOpened = false
      setTimeout(() => {
        this.$parent.popupOpened = true
      }, 50);
      setTimeout(() => {
        document.querySelector('.popup img').scrollIntoView({block: "start", behavior: "smooth"})
      }, 500)
    },
    yearName(year) {
    let txt;
    let count = year % 100;
    if (count >= 5 && count <= 20) txt = 'лет'
    else {
      count = count % 10
      if (count == 1) txt = 'год'
      else if (count >= 2 && count <= 4)  txt = 'года'
      else txt = 'лет'
    }
    return " "+txt
    },
    changeView(valOld, valNew) {
      if (isNaN(this[valNew])) {
        this[valNew] = 5000
      }
      this[valOld] = this[valNew]
    },
    onSliderFocus(name) {
      document.querySelector(`.${name}Input`).blur()
    },
    blurHandler(e, name) {
      e.target.setAttribute('type', 'text')
      this[name + 'Input'] = this[name + 'Input'].toLocaleString('ru')
      this.resize(name)
    },
    focusHandler(e, name) {
      this[name + 'Input'] = +this[name + 'Input'].toString().split(' ').join('')
      e.target.setAttribute('type', 'number')
    },
    handleInput(e, valOld, valNew, { maxlength, minlength, max, min }) {
      this.resize(valOld)
      
      this[valNew] = +e.target.value
      if (!+this[valNew]) this[valNew] = 0
      if (+this[valNew] === 0) return
      this[valNew] = +e.target.value.split('.').join('').split(',').join('')
      e.target.value = +this[valNew]

      if (e.target.value.length >= minlength && +e.target.value>= +min) {
        if (e.target.value.length > maxlength || +e.target.value> +max ) {
          this[valNew] = Math.floor((+e.target.value)/10)
          this[valOld] = Math.floor((+e.target.value)/10)
          this.resize(valOld)
        } 
        else this[valOld] = +e.target.value
      }
    },
    handleInputChange(valOld, valNew, { min, max, minlength, maxlength }) {
      if (this[valNew].length > +maxlength || 
        +this[valNew] > +max) {
          this[valNew] = +max
          this[valOld] = +max
        }
      else if (this[valNew].length < +minlength || 
        +this[valNew] < +min) {
          this[valNew] = +min
          this[valOld] = +min
        }
      else this[valOld] = +this[valNew]
    },
    formatNumber(val, ceil) {
      let str = ceil? val
        :val.split('.').join('').split(',').join('')
      str = (+str).toLocaleString('ru')
      return str || 0
    },
    getForecast(finTool) {
      let cards = []
      let indexes = []
      let moneyInDate = this.getStockpilingToDate(this.timeVal*12, this.moneyVal, this.$parent.finTools[finTool])
      let moneyVal = moneyInDate || 15000

      let data = this.$parent.dimensions
      data.forEach((item, i) => {
        let card = null
        item.dataset.forEach((el, id) => {
          let minPrice = Math.floor(this.getPriceToDate(this.timeVal, {
            coefficient: item.coefficient,
            startPrice: item.startPrice*el.min,
          }))
          let maxPrice = Math.floor(this.getPriceToDate(this.timeVal, {
            coefficient: item.coefficient,
            startPrice: item.startPrice*el.max,
          }))
          if (moneyVal > minPrice) {
            indexes[i]= +id
            card = {
              startPrice: Math.floor(moneyVal<maxPrice? moneyVal: maxPrice),
              coefficient: item.coefficient,
              name: el.name,
              description: el.description,
              min: el.min,
              max: el.max,
              icon: el.icon,
              value: Math.floor(moneyVal<maxPrice? moneyVal: maxPrice),
            }
          }
        })
        cards.push(card)
        this.indexesFin[finTool] = [...indexes]
      })
      return cards
    },
    btnAnimation() {
      let el = document.querySelector('.enter a.btn')
      if (this.animation) return
      let animation = el.animate([
        {transform: 'translate(0)'},
        {transform: 'translate(0, -5px)'},
      ], 100)
      this.animation = true
      animation.addEventListener('finish', e => {
        let animation = el.animate([
          {transform: 'translate(0, -5px)'},
          {transform: 'translate(0)'},
        ], 100)
        setTimeout(() => {
          this.animation = false
        }, 200)
      })
    }
  },
  watch: {
    moneyVal() {
      this.changeView('moneyValInput', 'moneyVal')
      this.cards = this.getCards()
      this.cardsForecastNone = this.getForecast(0) 
      this.cardsForecastBank = this.getForecast(1) 
      this.cardsForecastInvest = this.getForecast(2)
      this.getMoneyInBank()
      this.getMoneyInInvest()
      this.btnAnimation()

      this.resize('moneyVal')
      if (!document.activeElement.classList.contains('moneyValInput')) {
        document.querySelector('.moneyValInput').setAttribute('type', 'text')
        this.moneyValInput= this.moneyVal.toLocaleString('ru')
      }
    },
    moneyValInput() {
      this.cards = this.getCards()
      this.cardsForecastNone = this.getForecast(0) 
      this.cardsForecastBank = this.getForecast(1) 
      this.cardsForecastInvest = this.getForecast(2)
      this.getMoneyInBank()
      this.getMoneyInInvest()
      this.btnAnimation()
    },
    timeVal() {
      this.changeView('timeValInput', 'timeVal')
      this.cardsForecastNone = this.getForecast(0) 
      this.cardsForecastBank = this.getForecast(1) 
      this.cardsForecastInvest = this.getForecast(2)
      this.getMoneyInBank()
      this.getMoneyInInvest()
      this.btnAnimation()

      this.resize('timeVal')
      if (!document.activeElement.classList.contains('timeValInput')) {
        document.querySelector('.timeValInput').setAttribute('type', 'text')
        this.timeValInput= this.timeVal.toLocaleString('ru')
      }
    },
    timeValInput() {
      this.timeValInput = +this.timeValInput
      this.cardsForecastNone = this.getForecast(0) 
      this.cardsForecastBank = this.getForecast(1) 
      this.cardsForecastInvest = this.getForecast(2)
      this.getMoneyInBank()
      this.getMoneyInInvest()
      this.btnAnimation()
    }
},
}
</script>


<style lang="scss" scoped>
@import '@/assets/main.scss';

#app .input-label {
  margin: 15px 0 0;
  padding: 18px 0;
  min-height: 65px;
  .input-val {
    max-height: 40px;
    line-height: 40px;
    position: relative;
    text-align: center;
    width: 100%;
    margin: 0;
    padding: 0;
  }
  .currency {
    position: absolute;
    transition: 0.1s ease;
    transform: translateX(80px);
    &.timeValCy {
      margin-right: -20px;
    }
  }
  .input-buffer{
    font-family: 'Rubik', sans-serif;
    font-weight: 500;
    font-size: 40px;
    position: absolute;
    top: -10000px;
    left: -10000px;
    visibility: hidden;
    white-space: nowrap;
  }
}

.blur {
  transition: 0.3s;
  filter: blur(10px);
}

.forecast {
  position: absolute;
  width: 100%;
  max-width: 425px;
  left: 50%;
  top: 52px;
  opacity: 0;
  transition: all 0.5s ease;
  transform: translate(-50%, 0);
}

.Home .forecast {
  height: 50vh;
  overflow: hidden;
  transform: translate(-50%, 200px);
  opacity: 0;
  padding: 0;
  margin: 0;
}

.Accumulation .forecast {
  height: 90vh;
  overflow: hidden;
  transform: translate(-150%, 0);
  opacity: 0;
}

.Forecast .forecast {
  padding: 0;
  margin: 0;
  transform: translate(-50%, 0);
  opacity: 1;

  height: auto;
  top: 52px;
  overflow: hidden;
  overflow-y: visible;
}

.output {
  header {
    padding: 20px;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.3) 0%, rgba(255, 255, 255, 0) 100%);
    border-radius: 15px 15px 5px 5px;
    h2 {
      font-family: 'Rubik', sans-serif;
      font-weight: bold;
      font-size: 28px;
      line-height: 33px;
    }
    .sub-heading {
      font-family: 'Rubik', sans-serif;
      font-weight: 500;
      font-size: 16px;
      line-height: 19px;
    }
  }
  .answers {
    .ans-container {
      padding: 10px 20px 20px;
      margin-bottom: 0px;
      &:last-child .grid {
        border: none;
      }
      h3 {
        font-family: 'Rubik', sans-serif;
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        display: flex;
        align-items: center;
      }
      .info-heading {
        background: rgba(244, 246, 255, 0.5);;
        padding: 0;
        margin-bottom: -2px;
        margin-left: 5px;
        display: block;
        border: none;
        border-radius: 50%;
        width: 16px;
        height: 16px;
        font-family: 'Rubik', sans-serif;
        font-weight: 500;
        font-size: 14px;
        line-height: 17px;
        color: $purple_highlight;
      }
      .grid {
        border-bottom: 2px solid rgba(255, 255, 255, 0.5);
        padding-bottom: 30px;
      }
      .result {
        padding-top: 15px;
        margin: 15px 0;
        height: 90px;
        overflow: hidden;
        background: linear-gradient(180deg, rgba(255, 255, 255, 0.25) 0%, rgba(255, 255, 255, 0) 100%);
        border-radius: 15px 15px 0px 0px;
        .value {
          color: $purple_highlight;
          font-family: 'Rubik', sans-serif;
          font-style: normal;
          font-weight: 500;
          font-size: 40px;
          line-height: 47px;
          display: flex;
          align-items: flex-end;
          justify-content: center;
          margin-bottom: 10px;
          span {
            display: block;
            margin-bottom: 5px;
            margin-left: 10px;
            font-size: 20px;
            line-height: 23px;
          }
        }
        .value-description {
          font-family: 'Rubik', sans-serif;
          font-size: 16px;
          font-weight: 500;
          line-height: 19px;
          letter-spacing: 0em;
          text-align: center;
          span {
            color: $purple_highlight;
          }
        }
      }
    }
  }
  
  .info.none {
    display: none;
  }
  .info.down {
    cursor:unset;
    background: #EB5757 no-repeat url('../assets/img/polygon.svg') center/contain;
  }
  .info.up {
    cursor: unset;
    background: #58AF76 no-repeat url('../assets/img/polygon-reverse.svg') center/contain;
  }

  .btn {
    cursor: pointer;
    font-family: 'Raleway', sans-serif;
    font-size: 18px;
    font-weight: 700;
    line-height: 21px;
    letter-spacing: 0em;
    text-align: center;
    text-decoration: none;
    color: $white;
    box-shadow: 8px 8px 20px rgba(36, 36, 36, 0.2);
    border-radius: 50px;
    border: none;
    width: fit-content;
    display: block;
    padding: 12px 20px;
    background: $btn_grad_1;
    margin: 30px auto 60px;
    transition: 0.1s ease;
  }
}

.card {
  cursor: pointer;
}

</style>